import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Info } from "@jti/ui";
import styles from "@jti/ui/src/components/Form/FieldWrapper.module.scss";
const ReferralInputValidationResult = ({ code, message, isValidated = true, }) => {
    if (isValidated || !code) {
        return _jsx(React.Fragment, {});
    }
    return (_jsx("div", { className: "validation-row", "data-testid": "voucherValidation", children: _jsx(Info, { variant: "error", message: message, className: styles.error }) }));
};
export default ReferralInputValidationResult;
